<div class="container">
  <!-- <div class="sidebar">
    <div class="icon"><img src="assets/imageChatbot/Bot.svg" /></div>
    <div class="icon" style="display: none;">
      <img src="assets/imageChatbot/Menu_My Stories.svg" />
    </div>
    <div class="icon" style="display: none;">
      <img src="assets/imageChatbot/Menu_Saved Stories.svg" />
    </div>
    <div class="icon" style="display: none;">
      <img src="assets/imageChatbot/Menu_Shared with Me.svg" />
    </div>
    <div class="icon" style="display: none;">
      <img src="assets/imageChatbot/Menu_Shared by You.svg" />
    </div>
  </div> -->
  <!-- <div class="main-content">
    <div class="question">
      <div class="question-icon">
        <img src="assets/imageChatbot/icon_question.svg" />
      </div>
      <h2>{{ inputValueShow }}</h2>
      <div class="question-icon" style="display:none;">
        <img src="assets/imageChatbot/icon_edit.svg" />
      </div>
      <div class="question-icon" *ngIf="isDiagnostic" id="Diagnostic" style="margin-left: auto;">
        <img src="assets/imageChatbot/diagnostic.jpg" (click)="fetchDiagnostic()" />
      </div>
    </div>
    <div class="question-break-line"></div>
   
    <div class="infoRibbon summaryPanel" #summaryText (click)="selectionSummaryBlock()" *ngIf="isCreateBtnClick && !failedCase">


      <div class="InfoRibbonText" *ngIf="!isSelectionSummary">
        <div class="InforRibbonTextValues" #inforRibbon [title]="summaryTitle" [innerHTML]="selectionSummary"></div>
      </div>
      <div class="InfoRibbonTextCompleteSummary" *ngIf="isSelectionSummary">
        <div class="InforRibbonEntireSummary" [innerHTML]="selectionSummary"></div>
      </div>

      <div class="InfoCollapse">
        <div class="arrowToggle info-collapse-icon"></div>
      </div>
    </div>
    
    <div [ngClass]="showSnapshot && !failedCase ? 'chart-snapshot' : 'chart'">

      
      <div class="outputData-config" [ngClass]="{ outputGap: is_indexing }" *ngIf="!showSnapshot && !failedCase">
        <div class="sigIndexContainer" *ngIf="is_indexing">
          <div class="sig-data-block" [ngClass]="{ not_active: isSig == false }" (click)="toggleSigBlock('Sig')">
            <div>Sig</div>
          </div>
          <div class="index-data-block" [ngClass]="{ itemDisable: isTranspose, active: isIndex }"
            (click)="toggleSigBlock('Index')">
            <div>Index</div>
          </div>
        </div>
        <div class="significanceContainer" *ngIf="!isIndex">
          <div class="significanceMainContainer" *ngIf="is_sigtesting && is_Time_Period_Present">
            <div class="significanceLabel">Significance</div>
            <div class="significanceDropDown significance">
              <div class="significance-block" (click)="togglePanel('significance')">
                <ng-container *ngIf="SignificanceVsReference">
                  <div class="sigNameContainer" title="{{ DefaultSampleSize }} : {{
                      replacePipe(SignificanceVsReference)
                    }}">
                      <div class="weighted-text-block">
                        {{ DefaultSampleSize }} :
                        {{ replacePipe(SignificanceVsReference) }}
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!SignificanceVsReference">
                    <div class="sigNameContainer" title="{{ DefaultSampleSize }}">
                      <div class="weighted-text-block">
                        {{ DefaultSampleSize }}
                      </div>
                    </div>
                  </ng-container>
                  <div class="arrow-weighted-block">
                    <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: sampleSizeDropdown }">
                    </div>
                  </div>
                </div>
                <div class="sampleSize-sub-items" *ngIf="sampleSizeDropdown">
                  <div *ngFor="let list of SampleSizeList" class="sub-items-block"
                    (click)="SampleSizeDropDownClick(list.key)" [ngClass]="{
                    disabled:
                      (list.key === 'Pairwise' && isDisablePairWise) ||
                      (list.key === 'Reference' && isDisableReference)
                  }">
                    <div class="sample_size_block">
                      <div class="sub-items-names">{{ list.key }}</div>
                    </div>
                    <div class="side-panel-arrow-sig" *ngIf="list.key === 'Reference'">
                      <div class="arrowToggle metric-list-open"></div>
                    </div>
                  </div>
                </div>
                <div class="Reference-sub-items-significance" *ngIf="isReference">
                  <div class="reference-panel-search">
                    <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="searchTextLevel1"
                      autocomplete="off" name="searchTextLevel1" />
                    <div class="search-icon">
                      <div class="search-icon-image"></div>
                    </div>
                  </div>
                  <div *ngFor="let list of IndexData" class="reference-sub-items-block" [ngClass]="{
                    hide: !list.Child.toLowerCase().includes(
                      searchTextLevel1.toLowerCase()
                    )
                  }" (click)="referenceDropDownClickIndexSignificance(list.Child)">
                    <div class="reference-icon-container">
                      <div class="radio-icon" [ngClass]="{
                        'radio-icon-active': isSelectedSignificance(list.Child)
                      }"></div>
                    </div>
                    <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                      <div class="sub-items-names">
                        {{ replacePipe(list.Child) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="confidenceLevelContainer" *ngIf="is_confidenceLevel.length > 0 && !isIndex">
            <div class="confidenceLevelMainContainer" *ngIf="is_Time_Period_Present">
              <div class="confidanceLabel">Confidence Level</div>
              <div class="confidanceDropDown confidance">
                <div class="confidence-block" [ngClass]="{ itemDisable: DefaultSampleSize == 'None' }"
                  (click)="togglePanel('confidence')">
                  <div class="confidence-text-block">
                    {{ DefaultConfidenceLevel }}
                  </div>
                  <div class="arrow-weighted-block arrowBlock">
                    <div class="arrowToggle arrowToggleIcon"
                      [ngClass]="{ arrowCollapsedIcon: confidenceLevelDropDown }"></div>
                  </div>
                </div>
                <div class="confidence-sub-items" *ngIf="confidenceLevelDropDown">
                  <div *ngFor="let list of is_confidenceLevel" class="sub-items-block"
                    (click)="confidenceDropDownClick(list.key)">
                    <div class="sub-items-names">{{ list.key }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ReferenceLevelContainer" *ngIf="isIndex">
            <div class="ReferenceLevelMainContainer">
              <div class="ReferenceLabel">Reference</div>
              <div class="ReferenceDropDown reference">
                <div class="Reference-block" (click)="togglePanel('reference')">
                  <div class="Reference-text-block-main">
                    <div class="Reference-text-block" title="{{ DefaultReferenceLevel }}">
                      {{ DefaultReferenceLevel }}
                    </div>
                  </div>
                  <div class="arrow-weighted-block referenceArrowBlock">
                    <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: referenceLevelDropDown }">
                    </div>
                  </div>
                </div>
                <div class="Reference-sub-items" *ngIf="referenceLevelDropDown">
                  <div class="reference-panel-search">
                    <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="searchTextLevel1"
                      autocomplete="off" name="searchTextLevel1" />
                    <div class="search-icon">
                      <div class="search-icon-image"></div>
                    </div>
                  </div>
                  <div *ngFor="let list of IndexData" class="reference-sub-items-block" [ngClass]="{
              hide: !list.Child.toLowerCase().includes(
                searchTextLevel1.toLowerCase()
              )
            }" (click)="referenceDropDownClick(list.Child)">
                    <div class="reference-icon-container">
                      <div class="radio-icon" [ngClass]="{
                  'radio-icon-active': isSelected(list.Child)
                }"></div>
                    </div>
                    <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                      <div class="sub-items-names">
                        {{ replacePipe(list.Child) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <div class="DataContainer" *ngIf="SampleSizeContainer && !showSnapshot">
          <div class="dataMainContainer">
            <div class="dataDropDownContainer dataDropdown">
              <div class="data-block-main" (click)="togglePanel('datadropdown')">
                <div class="sigNameContainer" title="{{ DefaultDataDropDown }}">
                  <div class="weighted-text-block">
                    {{ DefaultDataDropDown }}
                  </div>
                </div>

                  <div class="arrow-weighted-block">
                    <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: dataDropDown }"></div>
                  </div>
                </div>
                <div class="data-sub-items" *ngIf="dataDropDown">
                  <div *ngFor="let list of dataDropDownList" class="sub-items-block" (click)="toggleDataBlock(list)">
                    <div class="sample_size_block">
                      <div class="sub-items-names">{{ list }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <div class="ChartMainContainer">
            <ng-container *ngIf="is_chart_visualization">
              <div class="iconsContainerMain" (mouseover)="showMainTooltip = true"
                (mouseleave)="showMainTooltip = false">
                <div class="iconsContainer" [ngClass]="{ itemDisable: !isChartView }">
                  <div class="tablePreview" [ngClass]="{ bg: displayTable }" (click)="onTableIconClick()">
                    <div class="iconContainer">
                      <div class="output-icon" [ngClass]="displayTable ? 'table-icon-white' : 'table-icon'"></div>
                    </div>
                  </div>

                  <div class="tooltipMain" (mouseover)="showStackTooltip = true"
                    (mouseleave)="showStackTooltip = false">


                    <div class="columnChartPreview" #preview
                      [ngClass]="{ bg: isVerticalStackChartClick && !disableStackChart,itemDisable: !disableStackChart && !isVerticalStackChartClick}">
                      <div class="iconContainer">
                        <div class="output-icon"
                          [ngClass]="isVerticalStackChartClick ? 'horizontal-bar-icon-white': 'horizontal-bar-icon'">
                        </div>
                      </div>
                    </div>
                    <div class="tooltip" *ngIf="showStackTooltip && (!disableStackChart && !isVerticalStackChartClick)">
                      <ul>
                        <ng-container *ngFor="let item of StackChartToolTip">
                          <li [innerHTML]="item"></li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>

                  <div class="tooltipMain" (mouseover)="showLineTooltip = true" (mouseleave)="showLineTooltip = false">
                    <div class="lineChartPreview" [ngClass]="{
                  bg: isLineChartClick && !disableLineChart,
                  itemDisable: !disableLineChart && !isLineChartClick
                }" (click)="onTrendChartIconClick()">
                      <div class="iconContainer">
                        <div class="output-icon" [ngClass]="
                      isLineChartClick
                        ? 'trend-chart-icon-white'
                        : 'trend-chart-icon'
                    "></div>
                      </div>
                    </div>
                    <div class="tooltip" *ngIf="showLineTooltip && (!disableLineChart && !isLineChartClick)">
                      <ul>
                        <ng-container *ngFor="let item of LineChartToolTip">
                          <li [innerHTML]="item"></li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                  <div class="tooltipMain" (mouseover)="showBarTooltip = true" (mouseleave)="showBarTooltip = false">
                    <div class="GrpVertical" [ngClass]="{
                  bg: isVerticalGroupBarChartClick || isVerticalBarChartClick
                }" (click)="VerticalChartClick('column')">
                      <div class="iconContainer">
                        <div class="output-icon grp-bar-icon" [ngClass]="
                      isVerticalGroupBarChartClick || isVerticalBarChartClick
                        ? 'grp-bar-icon-white'
                        : 'grp-bar-icon'
                    "></div>
                      </div>
                    </div>
                    <div class="tooltip" *ngIf="showBarTooltip && (!isChartView)">
                      <ul>
                        <ng-container *ngFor="let item of BarChartToolTip">
                          <li [innerHTML]="item"></li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="tooltip" *ngIf="showMainTooltip && (!isChartView)">
                  <ul>
                    <ng-container *ngFor="let item of GeneralToolTip">

                      <li [innerHTML]="item"></li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </ng-container>
          </div>

          
          <div class="TotalTransposeContainer">
            <div class="Totaltranpose-block total-block" [ngClass]="{ itemDisable: isTranspose }"
              (click)="OnTotalClick()" *ngIf="
               dataObject !=null &&
               this.dataObject['RowNesting'] !=null &&
               this.dataObject['RowNesting'].length>
            0
            ">
              <div class="checkbox-icon" [ngClass]="{ 'checkbox-icon-active': isTotal }"></div>
              <div class="btn-text">Total</div>
            </div>
            <div class="Totaltranpose-block transpose-block" [ngClass]="{
              itemDisable: isLineChartClick || isTotal || isPairWise || isIndex
            }" (click)="OnTransposeClick()" *ngIf="is_TransposeBtn">
              <div class="checkbox-icon" [ngClass]="{ 'checkbox-icon-active': isTranspose }"></div>
              <div class="btn-text">Transpose</div>
            </div>
          </div>
         
          <div class="exports-download-container" *ngIf="isCreateBtnClick">
            <div class="export-blocks" title="Export to Excel" [ngClass]="{'disabled':!isCreateBtnClick}"
              (click)="handleExportClick()">
              <div class="excel-download-icon excel-download-inactive"></div>
            </div>
            <div class="export-blocks" title="Export to PPT" [ngClass]="{ 'disabled':
          !(pptExport &&
          (isVerticalGroupBarChartClick ||
            isVerticalBarChartClick ||
            isVerticalStackChartClick ||
            isLineChartClick))
         }" (click)="handlePPTExportClick()">
              <div class="ppt-download-icon ppt-download-inactive"></div>
            </div>
           
        </div>

        
      </div>
      <div class="extraSelections" *ngIf="showExtraSelections">
        <div class="sigIndexArea">
          <div class="sigArea">
            <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
              [ngClass]="{'initialSelected': isSigSelected}" (click)="onSigType($event);select('sig',$event)">
              <p style="width:80%;text-align: center; font-size: 0.75rem;">Sig</p>
              <img *ngIf="significanceTypes.length > 1" src="../../../assets/ImagesSnapshot/Public/key-downDown.svg"
                alt="" class="icon-sig">
            </div>
            <div *ngIf="sigTypeDropdown && significanceTypes.length > 1" class="a" DocumentClick
              (DocumentClicked)="closeSigDropdown()">
              <div *ngFor="let type of significanceTypes" class="dropdown-values-sig"
                (click)="onSigTypeClick(type,$event)">
                <div style="padding-top:3%"><input type="radio" name="type" [value]="type.value"
                    [checked]="type.selected" class="inputValues">
                </div>
                <div class="itemData" title="{{type.name}}">{{type.name}}</div>
              </div>

            </div>

          </div>
          <div class="indexArea" [ngClass]="{'initialSelected': isIndexSelected}" (click)="select('index',$event)">
            <p style="width:100%;height:100%;text-align: center;padding-top:0.3rem">Index</p>
          </div>
        </div>
        <div class="dropdown-container">

          <div class="significanceDropdown" DocumentClick (DocumentClicked)="closeSignificance()"
            *ngIf="sigConBaseToggle">
            <div>Significance</div>
            <div class="dd" (click)="onSignificanceDropdown()">
              <p style="padding-top: 2.5%;padding-left: 7%;">{{displaySignificance}}</p>
              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': significanceDropdownToggle}" style="top:23%">
              </div>
            </div>
            <div *ngIf="significanceDropdownToggle" class="b">
              <div *ngFor="let item of significanceVal" class="dropdown-values"
                (click)="significanceSelected1(item,$event)">

                <div style="display:flex; width:100%;position:relative">
                  <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                    [ngClass]="{'selected-item': selectedSignificance === item}">
                    <span style="padding-left:2%">{{item.key}}</span>
                  </div>
                  <div
                    style="width:15%;display: flex;align-items: center;justify-content:end;position:absolute;left:85%;top:10%"
                    *ngIf="item.key=='Reference'">
                    <img src="../../../assets/images/common/Right_Arrow.svg" alt="" class="rightIcon">
                  </div>

                </div>
                <div *ngIf="item.key=='Reference' && displayBrand" class="mainBrandDiv">
                  <div class="search-row-block" (click)="searchBoxClick($event)">
                    <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
                    <div class="search-icon"></div>
                  </div>
                  <div style="height:9rem;overflow: auto;">
                    <div *ngFor="let brand of allSigBrands| search : searchQuery : ['MetricOption'];let i = index"
                      class="brandsDiv" (click)="brandSig(brand,$event)"
                      [ngClass]="{'selected-item': selectedReference === brand}">
                      <div style="padding-top:3%"><input type="radio" name="section" [value]="brand.key"
                          [checked]="brand.isSelected" class="inputValues">
                      </div>
                      <div class="brandPara" style="padding-left:4%" title="{{brand.MetricOption}}">
                        {{brand.MetricOption}}</div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div class="confidenceLeveldropdown DNN" (click)="onCLclick()" *ngIf="sigConBaseToggle">
            <div>Confidence Level </div>
            <div class="dd" (click)="onConfidenceLevelDropdown()">
              <p style="padding-top: 2.5%;padding-left: 7%;">{{displayConfidenceLevel}}</p>
              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': ConfidenceLevelDropDownToggle}"
                style="top:23%">
              </div>
            </div>
            <div *ngIf="ConfidenceLevelDropDownToggle" class="Confidence-level-dropdown">
              <div *ngFor="let item of confidenceLevel" class="dropdown-values"
                (click)="confidenceLevelSelected($event)">
                <div style="display:flex; width:100%;position:relative">
                  <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                    [ngClass]="{'selected-item': displayConfidenceLevel === item.key}">
                    <span style="padding-left:2%">{{item.key}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="referenceDropdownCSS" *ngIf="!sigConBaseToggle">
            <div>Reference</div>
            <div class="dd-ref" (click)="onReferenceDropdown()" DocumentClick
              (DocumentClicked)="closeReferenceDropdown()">
              <p class="brandDisplayDiv">{{displayReference}}</p>
              <img src="../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
            </div>
            <div *ngIf="referenceDropdownToggle" class="ref">
              <div class="search-row-block" (click)="searchBoxClick($event)">
                <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
                <div class="search-icon"></div>
              </div>
              <div style="height:10rem;overflow-y:auto ;">
                <div *ngFor="let item of allbrands| search : searchQuery : ['MetricOption'];let i = index"
                  class="ref-dropdown-values" (click)="referenceSelected(item)"
                  [ngClass]="{'selected-item': selectedReference === item}">
                  <div style="padding-top:3%;width:13%"><input type="radio" name="section" [value]="item.MetricOption"
                      [checked]="item.isSelected" class="inputValues">
                  </div>
                  <div class="brandPara" title="{{item.MetricOption}}">{{item.MetricOption}}</div>

                </div>
              </div>

            </div>
          </div>

          <div class="baseDropdown">
            <div>Base</div>
            <div class="dd" (click)="onBaseDropdown()" DocumentClick (DocumentClicked)="closeBaseDropdown()">
              <p style="padding-top: 2.5%;padding-left: 7%;">{{baseselected}}</p>
              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': BaseDropDownToggle}" style="top:23%"></div>
            </div>
            <div *ngIf="BaseDropDownToggle && isAnswerBase" class="Base-dropdown"
              [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
              <div *ngFor="let item of base" class="dropdown-values" (click)="baseSelected($event)">
                <div style="display:flex; width:100%;position:relative">
                  <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                    [ngClass]="{'selected-item': baseselected === item.key}">
                    <span style="padding-left:2%">{{item.key}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="BaseDropDownToggle && !isAnswerBase" class="Base-dropdown"
              [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
              <div *ngFor="let item of base2" class="dropdown-values" (click)="base2Selected($event)">
                <div style="display:flex; width:100%;position:relative">
                  <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                    [ngClass]="{'selected-item': baseselected === item.key}">
                    <span style="padding-left:2%">{{item.key}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="weightdropdownContainer" *ngIf="weight.length>1">
            <div>Weight </div>
            <div class="dd" (click)="onWeightDropdown()" DocumentClick (DocumentClicked)="closeWeightDropdown()">
              <p style="padding-top: 2.5%;padding-left: 7%;">{{weightSelectedValue}}</p>
              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': weightDropDownToggle}" style="top:23%"></div>
            </div>
            <div *ngIf="weightDropDownToggle" class="weight-dropdown"
              [ngClass]="{'Index-weight-dropdown': isIndexSelected}">
              <div *ngFor="let item of weight" class="dropdown-values" (click)="weightSelected($event)">
                <div style="display:flex; width:100%;position:relative">
                  <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                    [ngClass]="{'selected-item': weightSelectedValue === item.key}">
                    <span style="padding-left:2%">{{item.key}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      
      <div [ngClass]="showSnapshot ? 'table-output-wrapper-snapshot' : 'table-output-wrapper'">

        <div class="table-output" *ngIf="!showSnapshot && !failedCase">
          <app-table-ouput *ngIf="displayTable" [data]="OutputdataObject" [isTranspose]="isTranspose"
            [isTotalBase]="isTotalBase" [isAnswerBase]="isAnswerBase" [isSampleSize]="isSampleSize"
            [selectedDataFormat]="selectedDataFormat" [isWeightedLabel]="isWeightedLabel"
            [DefaultConfidenceLevel]="DefaultConfidenceLevel" [isWeightedNumerator]="isWeightedNumerator"
            [isUnWeightedNumerator]="isUnWeightedNumerator" [insufficientBase]="insufficientBase" [LowBase]="LowBase"
            [DefaultSampleSize]="DefaultSampleSize" [isSampleSizeBlock]="isSampleSizeBlock"
            [isWeightedSampleBlock]="isWeightedSampleBlock" [isPairWise]="isPairWise" [threshold]="threshold"
            [selectedIndex]="selectedIndex" [isIndex]="isIndex" [selectedWeight]="selectedWeight"></app-table-ouput>

           
            <app-vertical-group-bar-chart *ngIf="isVerticalGroupBarChartClick" [insufficientBase]="insufficientBase"
              [LowBase]="LowBase"></app-vertical-group-bar-chart>
            <app-vertical-bar-chart *ngIf="isVerticalBarChartClick" [insufficientBase]="insufficientBase"
              [LowBase]="LowBase"></app-vertical-bar-chart>
            <app-stackChart *ngIf="isVerticalStackChartClick" [insufficientBase]="insufficientBase"
              [LowBase]="LowBase"></app-stackChart>
            <app-lineChart *ngIf="isLineChartClick" [insufficientBase]="insufficientBase"
              [LowBase]="LowBase"></app-lineChart>
            

        </div>
        <div class="outputWidgetArea" *ngIf="" style="width:100%;height:100%;" id="widget-display-div">
          <app-custom-widget-output style="width:100%;height:100%;"
            [outputData]="output_details"></app-custom-widget-output>
        </div>
        <app-output-popup *ngIf="showSnapshot && !failedCase" [id]="filteredWidgetID" [snapProduct]="'custom'"
          [popUpParameter]="filteredWidgetData.widget_name" [customData]="filteredWidgetData"
          [showSnapshotARK]="showSnapshot"></app-output-popup>
        
        <div *ngIf="isInsightspopupOpen" class="insights">
          <p *ngIf="failedCase">{{ insightsVal }}</p>
          <ul *ngIf="!failedCase">
            <li *ngFor="let detail of insightsVal">{{ detail }}</li>
          </ul>
        </div>

        <app-insights-popup *ngIf="isInsightspopupOpen"></app-insights-popup>
        <div class="insightsbuttonContainer">
          <div class="insigths_btn" *ngIf="isInsightsBtnEnabled" (click)="OnInsigthsbuttonClick()">
            <div class="btn-text">Insights</div>
          </div>
        </div>

      </div>

    </div>
    <div class="insight-input-section" style="display: none;">
      <div class="insight-input-section-box">
        <button (click)="openInsights()" class="insight-input-icon">
          <img src="assets/imageChatbot/Icon_Add your insights.svg" />
        </button>
        <input type="text" placeholder="Insights" />
      </div>
      <div class="insight-icons">
        <button class="insight-icon">
          <img src="assets/imageChatbot/Share.svg" />
        </button>
        <button class="insight-icon">
          <img src="assets/imageChatbot/Download.svg" />
        </button>
        <button class="insight-icon">
          <img src="assets/imageChatbot/More.svg" />
        </button>
      </div>
    </div>
    <div class="footer" style="display: none;">
      <div class="footer-button">Do you want to know about another brand?</div>
      <div class="footer-button" style="display: none;">Another period?</div>
      <div class="footer-button" style="display: none;">Why something went up or down?</div>
      <div class="footer-button" style="display: none;">Do you want to know about another brand?</div>
    </div>
    <div class="input-section">
      <input [(ngModel)]="inputValue" (keyup.enter)="sendInputMessage()" type="text" placeholder="Ask something..."
        style="height:80px" />
      <button (click)="sendInputMessage()" class="send-button">
        <img src="assets/imageChatbot/send_icon.svg" class="insight-icon" />
      </button>
    </div>
    <app-insights-popup *ngIf="isInsightspopupOpen"></app-insights-popup>
  </div> -->
  
  <aside class="left-panel">
    <div class="logo-section">
        <div class="askme-logo"></div>
        <span class="askme-title">ASK ME</span>
    </div>
<!-- Comment it for now -->

    <!-- <nav class="icon-nav">
        <button class="icon-btn chats" aria-label="Chats"></button>
        <button class="icon-btn star" aria-label="Star"></button>
        <button class="icon-btn question" aria-label="Q"></button>
    </nav> -->
    <button class="icon-btn home" aria-label="Home" (click)="redirectToLandingPage()"></button>
</aside>
<main class="open-panel hidden">
    <header class="open-panel-header">
        <h2 class="panel-title">Chats</h2>
        <div class="filter-btn" aria-label="Filter"></div>
    </header>
    <section class="history-list">
        <div class="history-card">
            <div class="card-logo"></div>
            <div class="card-text">Show Imagery for Brand X across Age Groups?</div>
        </div>
        <div class="history-card">
            <div class="card-logo"></div>
            <div class="card-text">How is consideration evolving for Brand A?</div>
        </div>
        <div class="history-card">
            <div class="card-logo"></div>
            <div class="card-text">How is Brand Equity for Aldi compared to competitors?</div>
        </div>
    </section>
</main>
<section class="right-panel" *ngIf="askMeLanding">
    <div class="prompts-section">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
            <h2 class="quick-guide-title">Quick Guide to Ask Me</h2>
            <button class="right-panel-close-btn" aria-label="Close" style="width:1.25rem;height:1.25rem;background:url('../../../assets/images/explorerPlus/Filter_Back.svg') center center/contain no-repeat;border-radius:0.5rem;border:none;cursor:pointer;"></button>
        </div>
        <div class="prompts-cards">
            <div class="prompt-card">
                <div class="prompt-icon ask"></div>
                <div class="prompt-title">Ask Anything</div>
                <div class="prompt-desc">Simply type your queries! Clarity is key to unlocking the most insightful responses.</div>
            </div>
            <div class="prompt-card">
                <div class="prompt-icon analyze"></div>
                <div class="prompt-title">Analyze Instantly</div>
                <div class="prompt-desc">Our AI will automatically analyze and provide insightful summaries and visualizations.</div>
            </div>
            <div class="prompt-card">
                <div class="prompt-icon chat"></div>
                <div class="prompt-title">Relive Conversations</div>
                <div class="prompt-desc">Effortlessly access your chat history to maintain context and continue previous explorations.</div>
            </div>
            <div class="prompt-card">
                <div class="prompt-icon save"></div>
                <div class="prompt-title">Smart Shortcuts</div>
                <div class="prompt-desc">Save your go-to prompts as "Saved Questions" for rapid analysis and consistent outcomes.</div>
            </div>
            <div class="prompt-card">
                <div class="prompt-icon control"></div>
                <div class="prompt-title">Your Questions, Your Control</div>
                <div class="prompt-desc">Manage your saved questions effortlessly – modify, keep what's useful, and remove what's not.</div>
            </div>
            <div class="prompt-card">
                <div class="prompt-icon collaborate"></div>
                <div class="prompt-title">Collaborate Seamlessly</div>
                <div class="prompt-desc">Collaborate seamlessly by sharing your AI interactions with colleagues or stakeholders.</div>
            </div>
            <div class="prompt-card">
                <div class="prompt-icon export"></div>
                <div class="prompt-title">Transform to Impact</div>
                <div class="prompt-desc">Convert your insights into presentations and organized spreadsheets with direct export to PPT and Excel.</div>
            </div>
            <div class="prompt-card">
                <div class="prompt-icon update"></div>
                <div class="prompt-title">Always Evolving</div>
                <div class="prompt-desc">Stay ahead of the curve with automatic updates on new features and enhancements.</div>
            </div>
        </div>
    </div>
    <div class="bottom-fixed-section">
        <div class="question-section">
            <h3 class="question-title">How can i help you today?</h3>
        </div>
        <footer class="footer-section">
            <div class="footer-search">
                <input class="footer-input" [(ngModel)]="inputValue" (keyup.enter)="sendInputMessage()" type="text" placeholder="Ask Me Anything..." />
                <button class="footer-send"  (click)="sendInputMessage()" aria-label="Send"></button>
            </div>
            <div class="search-exp-logo">
               <img src="../../../assets/images/explorerPlus/Exp_logo.svg" alt="Explorer+ Logo" /> 
            </div>
        </footer>
    </div>
</section>

<section class="snapshot-panel" *ngIf="!askMeLanding">
  <div class="snapshot-content">
      <div class="snapshot-row">
          <div class="ai-avatar">
              <div class="ai-avatar-img"></div>
          </div>
          <div class="question-card">
              <div class="question-card-text">{{inputValueShow}}
                  <div class="question-card-actions">
                      <button class="question-action edit" aria-label="Edit"></button>
                      <button class="question-action star" aria-label="Star"></button>
                      <button class="question-action share" aria-label="Share"></button>
                      <button class="question-action trash" aria-label="Delete"></button>
                  </div>
              </div>
          </div>
          <div class="question-icon" *ngIf="isDiagnostic" id="Diagnostic" style="margin-left: auto;">
            <img src="assets/imageChatbot/diagnostic.jpg" (click)="fetchDiagnostic()" />
          </div>
      </div>
      <div class="output-area">
          <div class="output-title-row">
              <!-- <div class="output-title">MDS for Brand X</div> -->
              <!-- <button class="output-download" aria-label="Download"></button> -->
              <div class="exports-popup-container" *ngIf="!failedCase">
                <div class="exports-popup-container-img-block"
                  [ngClass]="{ 'exports-popup-container-img-block-Active' : isExportspopup}" (click)="Exportspopup()"></div>
                <div class="setting-container showPanel"
                  [ngStyle]="{right:isInsightsBtnEnabled && is_AI_Integration?'8.5%':'1%'}" *ngIf="isExportspopup">
                  <!-- <div class="setting-blocks editablePPTSettings"  *ngIf="editablePPT" (click)="OnExportClicked('ppt',true)">
                              <div class="setting-block-icon ppt-icon-trend"></div>
                              <div class="setting-block-name">PPT Trended (Editable)</div>
                          </div> -->
                  <div class="setting-blocks editablePPTSettings" [ngClass]="{ 'disabled':
                          !(pptExport &&
                          (isVerticalGroupBarChartClick ||
                            isVerticalBarChartClick ||
                            isVerticalStackChartClick ||
                            isLineChartClick))
                        }" (click)="handlePPTExportClick()">
                    <div class="setting-block-icon ppt-icon"></div>
                    <div class="setting-block-name">PPT</div>
                  </div>
                  <!-- <div class="setting-blocks screengrabPPTSettings"  *ngIf="staticPPT" (click)="screengrabPPTClicked()">
                              <div class="setting-block-icon ppt-icon"></div>
                              <div class="setting-block-name">PPT (Static)</div>
                          </div> -->
                  <!-- excelexportClicked() -->
                  <div class="setting-blocks excelexportSettings" [ngClass]="{'disabled':!isCreateBtnClick}"
                    (click)="handleExportClick()">
                    <div class="setting-block-icon excel-icon"></div>
                    <div class="setting-block-name">Excel</div>
                  </div>
                  <!-- <div class="setting-blocks excelexportSettings"  (click)="OnExportClicked('excel', true)">
                              <div class="setting-block-icon excel-icon-trend"></div>
                              <div class="setting-block-name">Excel (Trendline)</div>
                          </div> -->
                </div>
              </div>
              <button *ngIf="!failedCase" class="output-summary" (click)="SelectionsummaryCollapseExpand('SelectionSummary')">Summary</button>
          </div>
          
          <div class="output-container scrollbar-custom">
              <div class="output-crosstab">
                <!-- <div class="infoRibbon summaryPanel" #summaryText (click)="selectionSummaryBlock()" *ngIf="isCreateBtnClick && !failedCase">


                  <div class="InfoRibbonText" *ngIf="!isSelectionSummary">
                    <div class="InforRibbonTextValues" #inforRibbon [title]="summaryTitle" [innerHTML]="selectionSummary"></div>
                  </div>
                  <div class="InfoRibbonTextCompleteSummary" *ngIf="isSelectionSummary">
                    <div class="InforRibbonEntireSummary" [innerHTML]="selectionSummary"></div>
                  </div>
            
                  <div class="InfoCollapse">
                    <div class="arrowToggle info-collapse-icon"></div>
                  </div>
                </div> -->
                
                  <div class="outputData-config" [ngClass]="{ outputGap: is_indexing }" *ngIf="!showSnapshot && !failedCase">
                    <div class="sigIndexContainer" *ngIf="is_indexing">
                      <div class="sig-data-block" [ngClass]="{ not_active: isSig == false }" (click)="toggleSigBlock('Sig')">
                        <div>Sig</div>
                      </div>
                      <div class="index-data-block" [ngClass]="{ itemDisable: isTranspose, active: isIndex }"
                        (click)="toggleSigBlock('Index')">
                        <div>Index</div>
                      </div>
                    </div>
                    <div class="significanceContainer" *ngIf="!isIndex">
                      <div class="significanceMainContainer" *ngIf="is_sigtesting && is_Time_Period_Present">
                        <div class="significanceLabel">Significance</div>
                        <div class="significanceDropDown significance">
                          <div class="significance-block" (click)="togglePanel('significance')">
                            <ng-container *ngIf="SignificanceVsReference">
                              <div class="sigNameContainer" title="{{ DefaultSampleSize }} : {{
                                  replacePipe(SignificanceVsReference)
                                }}">
                                <div class="weighted-text-block">
                                  {{ DefaultSampleSize }} :
                                  {{ replacePipe(SignificanceVsReference) }}
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="!SignificanceVsReference">
                              <div class="sigNameContainer" title="{{ DefaultSampleSize }}">
                                <div class="weighted-text-block">
                                  {{ DefaultSampleSize }}
                                </div>
                              </div>
                            </ng-container>
                            <div class="arrow-weighted-block">
                              <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: sampleSizeDropdown }">
                              </div>
                            </div>
                          </div>
                          <div class="sampleSize-sub-items" *ngIf="sampleSizeDropdown">
                            <div *ngFor="let list of SampleSizeList" class="sub-items-block"
                              (click)="SampleSizeDropDownClick(list.key)" [ngClass]="{
                                disabled:
                                  (list.key === 'Pairwise' && isDisablePairWise) ||
                                  (list.key === 'Reference' && isDisableReference)
                              }">
                                <div class="sample_size_block">
                                  <div class="sub-items-names">{{ list.key }}</div>
                                </div>
                                <div class="side-panel-arrow-sig" *ngIf="list.key === 'Reference'">
                                  <div class="arrowToggle metric-list-open"></div>
                                </div>
                              </div>
                            </div>
                            <div class="Reference-sub-items-significance" *ngIf="isReference">
                              <div class="reference-panel-search">
                                <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="searchTextLevel1"
                                  autocomplete="off" name="searchTextLevel1" />
                                <div class="search-icon">
                                  <div class="search-icon-image"></div>
                                </div>
                              </div>
                              <div *ngFor="let list of IndexData" class="reference-sub-items-block" [ngClass]="{
                                hide: !list.Child.toLowerCase().includes(
                                  searchTextLevel1.toLowerCase()
                                )
                              }" (click)="referenceDropDownClickIndexSignificance(list.Child)">
                                <div class="reference-icon-container">
                                  <div class="radio-icon" [ngClass]="{
                                    'radio-icon-active': isSelectedSignificance(list.Child)
                                  }"></div>
                                </div>
                                <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                                  <div class="sub-items-names">
                                    {{ replacePipe(list.Child) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="confidenceLevelContainer" *ngIf="is_confidenceLevel.length > 0 && !isIndex">
                        <div class="confidenceLevelMainContainer" *ngIf="is_Time_Period_Present">
                          <div class="confidanceLabel">Confidence Level</div>
                          <div class="confidanceDropDown confidance">
                            <div class="confidence-block" [ngClass]="{ itemDisable: DefaultSampleSize == 'None' }"
                              (click)="togglePanel('confidence')">
                              <div class="confidence-text-block">
                                {{ DefaultConfidenceLevel }}
                              </div>
                              <div class="arrow-weighted-block arrowBlock">
                                <div class="arrowToggle arrowToggleIcon"
                                  [ngClass]="{ arrowCollapsedIcon: confidenceLevelDropDown }"></div>
                              </div>
                            </div>
                            <div class="confidence-sub-items" *ngIf="confidenceLevelDropDown">
                              <div *ngFor="let list of is_confidenceLevel" class="sub-items-block"
                                (click)="confidenceDropDownClick(list.key)">
                                <div class="sub-items-names">{{ list.key }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
            
                      <div class="ReferenceLevelContainer" *ngIf="isIndex">
                        <div class="ReferenceLevelMainContainer">
                          <div class="ReferenceLabel">Reference</div>
                          <div class="ReferenceDropDown reference">
                            <div class="Reference-block" (click)="togglePanel('reference')">
                              <div class="Reference-text-block-main">
                                <div class="Reference-text-block" title="{{ DefaultReferenceLevel }}">
                                  {{ DefaultReferenceLevel }}
                                </div>
                              </div>
                              <div class="arrow-weighted-block referenceArrowBlock">
                                <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: referenceLevelDropDown }">
                                </div>
                              </div>
                            </div>
                            <div class="Reference-sub-items" *ngIf="referenceLevelDropDown">
                              <div class="reference-panel-search">
                                <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="searchTextLevel1"
                                  autocomplete="off" name="searchTextLevel1" />
                                <div class="search-icon">
                                  <div class="search-icon-image"></div>
                                </div>
                              </div>
                              <div *ngFor="let list of IndexData" class="reference-sub-items-block" [ngClass]="{
                          hide: !list.Child.toLowerCase().includes(
                            searchTextLevel1.toLowerCase()
                          )
                        }" (click)="referenceDropDownClick(list.Child)">
                                <div class="reference-icon-container">
                                  <div class="radio-icon" [ngClass]="{
                              'radio-icon-active': isSelected(list.Child)
                            }"></div>
                                </div>
                                <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                                  <div class="sub-items-names">
                                    {{ replacePipe(list.Child) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
            
                    <div class="DataContainer" *ngIf="SampleSizeContainer && !showSnapshot">
                      <div class="dataMainContainer">
                        <div class="dataDropDownContainer dataDropdown">
                          <div class="data-block-main" (click)="togglePanel('datadropdown')">
                            <div class="sigNameContainer" title="{{ DefaultDataDropDown }}">
                              <div class="weighted-text-block">
                                {{ DefaultDataDropDown }}
                              </div>
                            </div>
            
                              <div class="arrow-weighted-block">
                                <div class="arrowToggle arrowToggleIcon" [ngClass]="{ arrowCollapsedIcon: dataDropDown }"></div>
                              </div>
                            </div>
                            <div class="data-sub-items" *ngIf="dataDropDown">
                              <div *ngFor="let list of dataDropDownList" class="sub-items-block" (click)="toggleDataBlock(list)">
                                <div class="sample_size_block">
                                  <div class="sub-items-names">{{ list }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
            
                     
            
                    <div class="ChartMainContainer" >
                      <ng-container *ngIf="is_chart_visualization">
                        <div class="iconsContainerMain" (mouseover)="showMainTooltip = true" (mouseleave)="showMainTooltip = false">
                          <div class="iconsContainer" [ngClass]="{ itemDisable: !isChartView }">
                            <div class="tablePreview" [ngClass]="{ bg: displayTable }" (click)="onTableIconClick()">
                              <div class="iconContainer">
                                <div class="output-icon" [ngClass]="displayTable ? 'table-icon-white' : 'table-icon'"></div>
                              </div>
                            </div>
            
                              <div class="tooltipMain" (mouseover)="showStackTooltip = true"
                                (mouseleave)="showStackTooltip = false">
            
            
                                <div class="columnChartPreview" #preview
                                  [ngClass]="{ bg: isVerticalStackChartClick && !disableStackChart,itemDisable: !disableStackChart && !isVerticalStackChartClick}">
                                  <div class="iconContainer">
                                    <div class="output-icon"
                                      [ngClass]="isVerticalStackChartClick ? 'horizontal-bar-icon-white': 'horizontal-bar-icon'">
                                    </div>
                                  </div>
                                </div>
                                <div class="tooltip" *ngIf="showStackTooltip && (!disableStackChart && !isVerticalStackChartClick)">
                                  <ul>
                                    <ng-container *ngFor="let item of StackChartToolTip">
                                      <li [innerHTML]="item"></li>
                                    </ng-container>
                                  </ul>
                                </div>
                              </div>
            
                              <div class="tooltipMain" (mouseover)="showLineTooltip = true" (mouseleave)="showLineTooltip = false">
                                <div class="lineChartPreview" [ngClass]="{
                              bg: isLineChartClick && !disableLineChart,
                              itemDisable: !disableLineChart && !isLineChartClick
                            }" (click)="onTrendChartIconClick()">
                                  <div class="iconContainer">
                                    <div class="output-icon" [ngClass]="
                                  isLineChartClick
                                    ? 'trend-chart-icon-white'
                                    : 'trend-chart-icon'
                                "></div>
                                  </div>
                                </div>
                                <div class="tooltip" *ngIf="showLineTooltip && (!disableLineChart && !isLineChartClick)">
                                  <ul>
                                    <ng-container *ngFor="let item of LineChartToolTip">
                                      <li [innerHTML]="item"></li>
                                    </ng-container>
                                  </ul>
                                </div>
                              </div>
                              <div class="tooltipMain" (mouseover)="showBarTooltip = true" (mouseleave)="showBarTooltip = false">
                                <div class="GrpVertical" [ngClass]="{
                              bg: isVerticalGroupBarChartClick || isVerticalBarChartClick
                            }" (click)="VerticalChartClick('column')">
                                  <div class="iconContainer">
                                    <div class="output-icon grp-bar-icon" [ngClass]="
                                  isVerticalGroupBarChartClick || isVerticalBarChartClick
                                    ? 'grp-bar-icon-white'
                                    : 'grp-bar-icon'
                                "></div>
                                  </div>
                                </div>
                                <div class="tooltip" *ngIf="showBarTooltip && (!isChartView)">
                                  <ul>
                                    <ng-container *ngFor="let item of BarChartToolTip">
                                      <li [innerHTML]="item"></li>
                                    </ng-container>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="tooltip" *ngIf="showMainTooltip && (!isChartView)">
                              <ul>
                                <ng-container *ngFor="let item of GeneralToolTip">
            
                                  <li [innerHTML]="item"></li>
                                </ng-container>
                              </ul>
                            </div>
                          </div>
                        </ng-container>
                      </div>
            
                     
                    <div class="TotalTransposeContainer" >
                      <div class="Totaltranpose-block total-block" [ngClass]="{ itemDisable: isTranspose }" (click)="OnTotalClick()"
                        *ngIf="
                           dataObject !=null &&
                           this.dataObject['RowNesting'] !=null &&
                           this.dataObject['RowNesting'].length>
                        0
                        ">
                          <div class="checkbox-icon" [ngClass]="{ 'checkbox-icon-active': isTotal }"></div>
                          <div class="btn-text">Total</div>
                        </div>
                        <div class="Totaltranpose-block transpose-block" [ngClass]="{
                          itemDisable: isLineChartClick || isTotal || isPairWise || isIndex
                        }" (click)="OnTransposeClick()" *ngIf="is_TransposeBtn">
                          <div class="checkbox-icon" [ngClass]="{ 'checkbox-icon-active': isTranspose }"></div>
                          <div class="btn-text">Transpose</div>
                        </div>
                      </div>
                     
                      <!-- <div class="exports-download-container" *ngIf="isCreateBtnClick">
                        <div class="export-blocks" title="Export to Excel" [ngClass]="{'disabled':!isCreateBtnClick}"
                          (click)="handleExportClick()">
                          <div class="excel-download-icon excel-download-inactive"></div>
                        </div>
                        <div class="export-blocks" title="Export to PPT" [ngClass]="{ 'disabled':
                      !(pptExport &&
                      (isVerticalGroupBarChartClick ||
                        isVerticalBarChartClick ||
                        isVerticalStackChartClick ||
                        isLineChartClick))
                     }" (click)="handlePPTExportClick()">
                          <div class="ppt-download-icon ppt-download-inactive"></div>
                        </div>
                        
                    </div>
             -->
                   
                  </div>
                  <!-- <div class="extraSelections" *ngIf="showExtraSelections">
                    <div class="sigIndexArea">
                      <div class="sigArea">
                        <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                          [ngClass]="{'initialSelected': isSigSelected}" (click)="onSigType($event);select('sig',$event)">
                          <p style="width:80%;text-align: center; font-size: 0.75rem;">Sig</p>
                          <img *ngIf="significanceTypes.length > 1" src="../../../assets/ImagesSnapshot/Public/key-downDown.svg"
                            alt="" class="icon-sig">
                        </div>
                        <div *ngIf="sigTypeDropdown && significanceTypes.length > 1" class="a" DocumentClick
                          (DocumentClicked)="closeSigDropdown()">
                          <div *ngFor="let type of significanceTypes" class="dropdown-values-sig"
                            (click)="onSigTypeClick(type,$event)">
                            <div style="padding-top:3%"><input type="radio" name="type" [value]="type.value"
                                [checked]="type.selected" class="inputValues">
                            </div>
                            <div class="itemData" title="{{type.name}}">{{type.name}}</div>
                          </div>
            
                        </div>
            
                      </div>
                      <div class="indexArea" [ngClass]="{'initialSelected': isIndexSelected}" (click)="select('index',$event)">
                        <p style="width:100%;height:100%;text-align: center;padding-top:0.3rem">Index</p>
                      </div>
                    </div>
                    <div class="dropdown-container">
            
                      <div class="significanceDropdown" DocumentClick (DocumentClicked)="closeSignificance()"
                        *ngIf="sigConBaseToggle">
                        <div>Significance</div>
                        <div class="dd" (click)="onSignificanceDropdown()">
                          <p style="padding-top: 2.5%;padding-left: 7%;">{{displaySignificance}}</p>
                          <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': significanceDropdownToggle}" style="top:23%">
                          </div>
                        </div>
                        <div *ngIf="significanceDropdownToggle" class="b">
                          <div *ngFor="let item of significanceVal" class="dropdown-values"
                            (click)="significanceSelected1(item,$event)">
            
                            <div style="display:flex; width:100%;position:relative">
                              <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                [ngClass]="{'selected-item': selectedSignificance === item}">
                                <span style="padding-left:2%">{{item.key}}</span>
                              </div>
                              <div
                                style="width:15%;display: flex;align-items: center;justify-content:end;position:absolute;left:85%;top:10%"
                                *ngIf="item.key=='Reference'">
                                <img src="../../../assets/images/common/Right_Arrow.svg" alt="" class="rightIcon">
                              </div>
            
                            </div>
                            <div *ngIf="item.key=='Reference' && displayBrand" class="mainBrandDiv">
                              <div class="search-row-block" (click)="searchBoxClick($event)">
                                <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
                                <div class="search-icon"></div>
                              </div>
                              <div style="height:9rem;overflow: auto;">
                                <div *ngFor="let brand of allSigBrands| search : searchQuery : ['MetricOption'];let i = index"
                                  class="brandsDiv" (click)="brandSig(brand,$event)"
                                  [ngClass]="{'selected-item': selectedReference === brand}">
                                  <div style="padding-top:3%"><input type="radio" name="section" [value]="brand.key"
                                      [checked]="brand.isSelected" class="inputValues">
                                  </div>
                                  <div class="brandPara" style="padding-left:4%" title="{{brand.MetricOption}}">
                                    {{brand.MetricOption}}</div>
                                </div>
                              </div>
            
                            </div>
            
                          </div>
                        </div>
                      </div>
                      <div class="confidenceLeveldropdown DNN" (click)="onCLclick()" *ngIf="sigConBaseToggle">
                        <div>Confidence Level </div>
                        <div class="dd" (click)="onConfidenceLevelDropdown()">
                          <p style="padding-top: 2.5%;padding-left: 7%;">{{displayConfidenceLevel}}</p>
                          <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': ConfidenceLevelDropDownToggle}"
                            style="top:23%">
                          </div>
                        </div>
                        <div *ngIf="ConfidenceLevelDropDownToggle" class="Confidence-level-dropdown">
                          <div *ngFor="let item of confidenceLevel" class="dropdown-values"
                            (click)="confidenceLevelSelected($event)">
                            <div style="display:flex; width:100%;position:relative">
                              <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                [ngClass]="{'selected-item': displayConfidenceLevel === item.key}">
                                <span style="padding-left:2%">{{item.key}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="referenceDropdownCSS" *ngIf="!sigConBaseToggle">
                        <div>Reference</div>
                        <div class="dd-ref" (click)="onReferenceDropdown()" DocumentClick
                          (DocumentClicked)="closeReferenceDropdown()">
                          <p class="brandDisplayDiv">{{displayReference}}</p>
                          <img src="../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
                        </div>
                        <div *ngIf="referenceDropdownToggle" class="ref">
                          <div class="search-row-block" (click)="searchBoxClick($event)">
                            <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
                            <div class="search-icon"></div>
                          </div>
                          <div style="height:10rem;overflow-y:auto ;">
                            <div *ngFor="let item of allbrands| search : searchQuery : ['MetricOption'];let i = index"
                              class="ref-dropdown-values" (click)="referenceSelected(item)"
                              [ngClass]="{'selected-item': selectedReference === item}">
                              <div style="padding-top:3%;width:13%"><input type="radio" name="section" [value]="item.MetricOption"
                                  [checked]="item.isSelected" class="inputValues">
                              </div>
                              <div class="brandPara" title="{{item.MetricOption}}">{{item.MetricOption}}</div>
            
                            </div>
                          </div>
            
                        </div>
                      </div>
            
                      <div class="baseDropdown">
                        <div>Base</div>
                        <div class="dd" (click)="onBaseDropdown()" DocumentClick (DocumentClicked)="closeBaseDropdown()">
                          <p style="padding-top: 2.5%;padding-left: 7%;">{{baseselected}}</p>
                          <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': BaseDropDownToggle}" style="top:23%"></div>
                        </div>
                        <div *ngIf="BaseDropDownToggle && isAnswerBase" class="Base-dropdown"
                          [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                          <div *ngFor="let item of base" class="dropdown-values" (click)="baseSelected($event)">
                            <div style="display:flex; width:100%;position:relative">
                              <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                [ngClass]="{'selected-item': baseselected === item.key}">
                                <span style="padding-left:2%">{{item.key}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="BaseDropDownToggle && !isAnswerBase" class="Base-dropdown"
                          [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                          <div *ngFor="let item of base2" class="dropdown-values" (click)="base2Selected($event)">
                            <div style="display:flex; width:100%;position:relative">
                              <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                [ngClass]="{'selected-item': baseselected === item.key}">
                                <span style="padding-left:2%">{{item.key}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
            
                      <div class="weightdropdownContainer" *ngIf="weight.length>1">
                        <div>Weight </div>
                        <div class="dd" (click)="onWeightDropdown()" DocumentClick (DocumentClicked)="closeWeightDropdown()">
                          <p style="padding-top: 2.5%;padding-left: 7%;">{{weightSelectedValue}}</p>
                          <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': weightDropDownToggle}" style="top:23%"></div>
                        </div>
                        <div *ngIf="weightDropDownToggle" class="weight-dropdown"
                          [ngClass]="{'Index-weight-dropdown': isIndexSelected}">
                          <div *ngFor="let item of weight" class="dropdown-values" (click)="weightSelected($event)">
                            <div style="display:flex; width:100%;position:relative">
                              <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                [ngClass]="{'selected-item': weightSelectedValue === item.key}">
                                <span style="padding-left:2%">{{item.key}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
            
                  </div>
                  -->
                  <div [ngClass]="showSnapshot ? 'table-output-wrapper-snapshot' : 'table-output-wrapper'">
            
                    <div class="table-output" *ngIf="!showSnapshot && !failedCase">
                      <app-table-ouput *ngIf="displayTable" [data]="OutputdataObject" [isTranspose]="isTranspose"
                        [isTotalBase]="isTotalBase" [isAnswerBase]="isAnswerBase" [isSampleSize]="isSampleSize"
                        [selectedDataFormat]="selectedDataFormat" [isWeightedLabel]="isWeightedLabel"
                        [DefaultConfidenceLevel]="DefaultConfidenceLevel" [isWeightedNumerator]="isWeightedNumerator"
                        [isUnWeightedNumerator]="isUnWeightedNumerator" [insufficientBase]="insufficientBase" [LowBase]="LowBase"
                        [DefaultSampleSize]="DefaultSampleSize" [isSampleSizeBlock]="isSampleSizeBlock"
                        [isWeightedSampleBlock]="isWeightedSampleBlock" [isPairWise]="isPairWise" [threshold]="threshold"
                        [selectedIndex]="selectedIndex" [isIndex]="isIndex" [selectedWeight]="selectedWeight"></app-table-ouput>
            
                        
                        <app-vertical-group-bar-chart *ngIf="isVerticalGroupBarChartClick" [insufficientBase]="insufficientBase"
                          [LowBase]="LowBase"></app-vertical-group-bar-chart>
                        <app-vertical-bar-chart *ngIf="isVerticalBarChartClick" [insufficientBase]="insufficientBase"
                          [LowBase]="LowBase"></app-vertical-bar-chart>
                        <app-stackChart *ngIf="isVerticalStackChartClick" [insufficientBase]="insufficientBase"
                          [LowBase]="LowBase"></app-stackChart>
                        <app-lineChart *ngIf="isLineChartClick" [insufficientBase]="insufficientBase"
                          [LowBase]="LowBase"></app-lineChart>
                        
            
                    </div>
                    
                    <app-output-popup *ngIf="showSnapshot && !failedCase" [id]="filteredWidgetID" [snapProduct]="'custom'"
                      [popUpParameter]="filteredWidgetData.widget_name" [customData]="filteredWidgetData"
                      [showSnapshotARK]="showSnapshot"></app-output-popup>
                    
            
                  </div>
            
               
              </div>
              <div class="output-insights" *ngIf="isInsightspopupOpen">
                  <div class="insights-div">
                      <div class="insights-icon">
                          <img src="../../../assets/images/explorerPlus/Insights_Icon.svg" alt="Insights Star" />
                      </div>
                      <div class="insights-text">
                          <h3 *ngIf="!failedCase">Insights:</h3>
          <p *ngIf="failedCase">{{ insightsVal }}</p>

                          <ul *ngIf="!failedCase">
                              
                              <li *ngFor="let detail of insightsVal">{{detail}}</li>
                              
                         </ul>
                      </div>
                  </div>
              </div>
          </div>
         
      </div>
      <div class="search-area">
          <div class="search-row">
              <div class="search-plus">
                  <button class="search-plus-btn" aria-label="New chat"></button>
              </div>
              <div class="search-box">
                  <input class="search-input" [(ngModel)]="inputValue" (keyup.enter)="sendInputMessage()" type="text" placeholder="Ask Me Anything..." />
                  <button class="search-send" (click)="sendInputMessage()" aria-label="Send"></button>
              </div>
          </div>
          <div class="search-exp-logo">
              <img src="../../../assets/images/explorerPlus/Exp_logo.svg" alt="Explorer+ Logo" />
          </div>
      </div>
  </div>
</section>

<div class="selection-summary-component" *ngIf="isselectionsummarycollapse">
  <div class="overLay visible"></div>
  <div class="selection-summary-container" [class.visible]="isselectionsummarycollapse2">
    <div class="selection-summary-block">
      <div class="selection-header">
        <div class="selection-text">{{isselectionHeader}}</div>
        <div class="selection-icon" (click)="OnCloseClick()">
          <div class="icon1"></div>
        </div>
      </div>
      <div class="save-selection-body" *ngIf="issavedselectionblock">
        <div class="save-selection-text">
          Please enter the selection name (max 50 characters)
        </div>
        <div class="save-selection-input">
          <input type="text" placeholder="Selection name.." [(ngModel)]="SaveSelectiontext" maxlength="50"
            autocomplete="off" name="SaveSelectiontext" (keydown)="onKeyDown($event)" />
        </div>
        <!-- <div class="save-selection-btn" (click)="SaveSelectionClick()">
          <div class="btn-text">Save</div>
        </div> -->
      </div>
      <div class="summary-view" *ngIf="!showSnapshot" [ngStyle]="{
                      height: !issavedselectionblock ? '94%' : '69%'
                    }">
        <div class="summary-view-outer">
          <div class="summary-header">Study Type</div>
          <div class="selection-summary-view-text">
            <div class="selection-header-container">
              <span class="selection-key">Study Type:</span>
              <span class="selection-value">{{selected_study}}</span>
            </div>
          </div>

          <div class="summary-header">Column</div>
          <div class="selection-summary-view-text">
            <div *ngFor="let selection of Columnselections" class="selection-header-container">
              <span class="selection-key">{{selection.key}}:</span>
              <span class="selection-value">{{selection.value}}</span>
            </div>
          </div>

          <div class="summary-header">Row</div>
          <div class="selection-summary-view-text">
            <div *ngFor="let selection of Rowselections" class="selection-header-container">
              <span class="selection-key">{{selection.key}}:</span>
              <span class="selection-value">{{selection.value}}</span>
            </div>
          </div>

          <div class="summary-header">Filters</div>
          <div class="selection-summary-view-text">
            <div *ngFor="let selection of AllSelections" class="selection-header-container">
              <span class="selection-key">{{selection.key}}:</span>
              <span class="selection-value">{{selection.value}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="summary-view" *ngIf="showSnapshot && !failedCase">
        <div class="summary-view-outer">
          <!-- Compare Across section -->
            <div class="summary-header">Compare Across</div>
            <div class="selection-summary-view-text">
              <div *ngFor="let title of titleSection" class="selection-header-container">
                <span class="selection-key">{{title.key}}:</span>
                <span class="selection-value">{{title.value}}</span>
              </div>
            </div>
          
          <!-- Entry Point section -->
            <div class="summary-header" *ngIf = "entryPoints.length > 0">Entry Point</div>
            <div class="selection-summary-view-text">
              <div *ngFor="let entry of entryPoints" class="selection-header-container">
                <span class="selection-key">{{entry.key}}:</span>
                <span class="selection-value">{{entry.value}}</span>
              </div>
            </div>
          
          <!-- Selections section -->
            <div class="summary-header">Selections</div>
            <div class="selection-summary-view-text">
              <div *ngFor="let selection of selections" class="selection-header-container">
                <span class="selection-key">{{selection.key}}:</span>
                <span class="selection-value">{{selection.value}}</span>
              </div>
            </div>
          </div>
          
      </div>
    </div>
  </div>
</div>
  <div class="loader-container" *ngIf="arktabaccess">
    <div class="loaderARK"></div>
  </div>